<script>
import { mapGetters } from 'vuex'
import Select from './BaseSelect'

export default {
  name: 'StoreTypeSelect',
  extends: Select,

  props: {
    filterable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters({
      storeTypes: 'master/storeTypes'
    }),

    options () {
      return this.storeTypes
    }
  }
}
</script>
